import { SelectData } from '../../../../models/common/types';

export const DefinedDocumentTypes: SelectData[] = [
    { id: '1', name: 'CMF / AIA Materials Pledge' },
    { id: '2', name: 'LEED v5 eligible documents' },
    { id: '4', name: 'LEED v5 LEM'},
    { id: '3', name: 'Other types' }
];